import { defineClient } from '@/services/api';

const endpoint = '/api/automate'
const apiClient = defineClient(endpoint);

export default {
    // Define the function to fetch badge layout
    async getBadgeLayout() {
        return await apiClient.get('/badge/layout');
    },

    // Define the function to fetch badge information based on badge number and last name
    async getBadgeInfo(params) {
        return await apiClient.get('/badge/info', { params });
    },

    badgeInfoToEmailForm(data) {
        const parsed = {
            name: `${data['First Name']} ${data['Last Name']}`.trim(),
            email: data['Email'] || '',
            company: data['Company'] || '',
            phone: data['Phone'] || '',
            job: data['Job Title'] || '',
            notes: '',
            address: '',
            demographics: ''
        };
    
        const baseKeys = ['First Name', 'Last Name', 'Email', 'Company', 'Phone', 'Job Title'];
        const addressKeys = ['Address 1', 'Address 2', 'City', 'State/Province', 'Zip Code', 'Country'];
    
        const addressParts = addressKeys.map(key => data[key]?.trim()).filter(Boolean);
        parsed.address = addressParts.join(', ');
    
        const demographicArray = [];
        for (const [key, value] of Object.entries(data)) {
            if (!baseKeys.includes(key) && !addressKeys.includes(key)) {
                demographicArray.push(`${key}: ${value ?? ''}`);
            }
        }
        parsed.demographics = demographicArray.join('\n');
        return parsed;
    },
};
